import { render, staticRenderFns } from "./ModalTurno.vue?vue&type=template&id=48ed3873&scoped=true&"
import script from "./ModalTurno.vue?vue&type=script&lang=js&"
export * from "./ModalTurno.vue?vue&type=script&lang=js&"
import style0 from "./ModalTurno.vue?vue&type=style&index=0&id=48ed3873&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed3873",
  null
  
)

export default component.exports